/* eslint-disable import/no-anonymous-default-export */
import styled from "styled-components";
import { ModalContainerStyleTypes, ModalStyleTypes } from "./Modal.type";

const OuterContainer = styled.div.attrs<ModalStyleTypes>((props) => ({
  className: `${props.enabled ? "opacity-1" : "opacity-0 pointer-events-none"
    } transition-opacity modal-x fixed w-full h-full top-0 left-0 flex items-center justify-center z-50`,
})) <ModalStyleTypes>``;

const Overlay = styled.div.attrs({
  className: `modal-overlay absolute w-full h-full bg-gray-900 opacity-50`,
})``;

const Modal = styled.div.attrs<ModalContainerStyleTypes>((props) => ({
  className: `modal-container bg-white w-11/12 md:w-8/12 lg:w-6/12 xl:w-6/12 max-w-full min-w-fit mx-auto rounded-xl shadow-xl z-50 overflow-y-auto max-h-full ${props.className}`,
}))`
  /* Estilos personalizados para el scrollbar vertical */
  &::-webkit-scrollbar {
    width: 12px; /* Ancho del scrollbar aumentado */
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
    border: 2px solid #f1f1f1;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Para Firefox */
  scrollbar-width: auto;
  scrollbar-color: #888 #f1f1f1;
`;

const ContentContainer = styled.div.attrs({
  className: `modal-content py-4 text-left px-6`,
})``;

const Header = styled.div.attrs({
  className: `flex justify-between items-center pb-3`,
})``;

const CloseButton = styled.div.attrs({
  className: `modal-close cursor-pointer z-50`,
})``;

export default {
  OuterContainer,
  Overlay,
  Modal,
  ContentContainer,
  Header,
  CloseButton,
};
